<template>
  <v-data-table
    :headers="headers"
    :items="users.result"
    sort-by="name"
    :search="search"
    class="elevation-1"
    :loading="users.loading"
    style="cursor:pointer"
    @click:row="userProfile"
   
  >
   <!-- @click:row="userDetails(users.result)" -->
    <template v-slot:top>
      <v-toolbar flat class="pa-3">
        <!-- <v-toolbar-title>Users</v-toolbar-title> -->
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search Users"
          single-line
          hide-details
        ></v-text-field>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" width="800px" persistent>
          <v-card v-if="user">
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
              <v-spacer></v-spacer>
              <v-icon color="blue darken-1" @click="close"> close </v-icon>
            </v-card-title>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template #[`item.actions`]="{ item }">
      <tr style="text-align: right; float: right">
        <td>
          <v-progress-circular
            v-if="modifying && item.code === userCode"
            indeterminate
            color="primary"
            :value="20"
          ></v-progress-circular>
          <v-menu
            v-else
            bottom
            origin="center"
            class="text-center"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list class="more">
              <v-list-item>
                <v-list-item-title @click="requestVerification(item)"
                  >Request Verification</v-list-item-title
                >
              </v-list-item>
              <!-- <v-list-item>
                <v-list-item-title @click="userProfile(item)">User Profile</v-list-item-title>
              </v-list-item> -->
              <v-list-item>
                <v-list-item-title @click="sendMoneyForUser(item)">Send Money</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </td>
      </tr>
      <!-- <v-icon small @click="changePassword">mdi-dots-vertical </v-icon> -->
      <!-- <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon> -->
    </template>
    <template v-slot:no-data> No users found </template>
  </v-data-table>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const reportNamespace = createNamespacedHelpers("report");

import UserService from "../../../services/users.service";
import { createUser } from "../../../model/user.model";

const usersNamespace = createNamespacedHelpers("users");
const { mapActions } = createNamespacedHelpers("users");
const sendmoneyNamespace = createNamespacedHelpers("sendmoney");

export default {
  props: {
    report: {
      type: String,
      default: "users",
    },
    params: {
      default: null,
    },
    view: {
      default: null,
    },
  },
  data: () => ({
    search: "",
    dialog: false,
    dialogDelete: false,
    changePasswordDialog: false,
    loading: false,
    modifying: false,
    userCode: null,
    fullname: "",
    errorMessage: null,
    validUser: true,
    editing: false,
    newPassword: "",
    confirmPassword: "",
    validPassword: true,
    accountTypes: [
      { value: "PAYAGENT", text: "Branch Agent" },
      { value: "PAYSUBAGENT", text: "Branch Cashier" },
    ],
    newPasswordRules: [
      (v) => !!v || "New Password is required",

      (v) => {
        if (!(v && v.length != "")) {
          return "Invalid Password";
        }
        return true;
      },
    ],
    confirmPasswordRules: [
      (v) => !!v || "Password is required",

      /*     (v) => {
        if (v && this.newPassword != this.confirmPassword) {
          return "Passwords don't match";
        }
      }, */

      (v) => {
        if (!(v && v.length != "")) {
          return "Invalid Password";
        }
        return true;
      },
    ],
    user: null,
    headers: [
      {
        text: "Name",
        align: "start",
        sortable: true,
        value: "fullname",
      },
      { text: "Email", value: "email" },
      { text: "Mobile", value: "mobile" },
      { text: "Email Verified", value: "email_verified" },
      
      { text: "Mobile Verified", value: "mobile_verified" },
      { text: "Enabled", value: "enabled" },
      { text: "KYC Checked", value: "kyc_verified" },
      { text: "Admin", value: "is_admin" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    nameRules: [
      (v) => !!v || "User fullname is required",
      (v) => {
        if (!(v && v.length != "")) {
          return "Invalid Name";
        }
        return true;
      },
    ],
    emailRules: [
      (v) => !!v || "User Email is required",
      (v) => {
        if (!(v && v.length != "")) {
          return "Invalid Email";
        }
        return true;
      },
    ],
    branchRules: [
      (v) => !!v || "Branch is required",
      (v) => {
        if (!(v && v.length != "")) {
          return "Invalid branch";
        }
        return true;
      },
    ],
    accountTypeRules: [
      (v) => !!v || "Account type is required",
      (v) => {
        if (!(v && v.length != "")) {
          return "Invalid account type";
        }
        return true;
      },
    ],
    passwordRules: [
      (v) => !!v || "User Password is required",
      (v) => {
        if (!(v && v.length != "")) {
          return "Invalid Password";
        }
        return true;
      },
    ],

    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },
    ...reportNamespace.mapState({
      users: (state) => state.users,
      branches: (state) => state.branches,
    }),
    ...usersNamespace.mapState({
      loggedInUser: (state) => state.user,
      selectedUser: (state) => state.selectedUser,
    }),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...sendmoneyNamespace.mapMutations(["mSendMoneyForUser"]),
    ...mapActions(["aChangeUserPassword"]),
    ...reportNamespace.mapActions(["getReport"]),
    ...usersNamespace.mapMutations(["mSetUser"]),
    accountTypeSelected() {
      if (this.user.accountType === "PAYSUBAGENT") {
        this.user.admin = false;
        this.user.companyOwner = false;
      }
    },
    initialize() {
      this.desserts = [];
    },
    async requestVerification(item) {
      try {
        this.modifying = true;
        this.userCode = item.code;
        const payload = {
          userCode: item.code,
        };
        const response = await UserService.requestVerification(payload);
        console.log("response", response);
      } catch (error) {
        //
      }
      this.modifying = false;
    },
    userProfile(item){
      
      
      console.log("user profile", item)
      const code =item.code
      this.$router.push(`/admin/documents/upload-document/${item.code}`)
      console.log("code", code)
    },

  /*   userDetails(data){
      console.log("itemss", data.code)
      this.$router.push(`/admin/user-profile/user-details`)
    }, */
    newUser() {
      this.editing = false;
      this.user = createUser({ company: this.$route.params.code });
      this.dialog = true;
    },
    editItem(item) {
      this.editing = true;
      this.user = createUser(item);
      console.log("item", item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    changePassword(item) {
      console.log("item", item);
      this.fullname = item.fullname;
      this.changePasswordDialog = true;
    },
    closeDialog() {
      this.changePasswordDialog = false;
    },

    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    getUser(item) {
      const userCode = item;
      console.log("user code");
      console.log("Users", userCode);
    },
    async updatePassword() {
      //const user = item.code

      this.loading = true;
      // To get selected user's code

      const userCode = this.users.result[2].code;
      const payload = {
        password: this.newPassword,
        userCode: userCode,
      };
      try {
        this.validPassword = this.$refs.changePasswordForm.validate();
        if (this.validPassword) {
          if (this.newPassword === this.confirmPassword) {
            await UserService.changeUserPassword(payload);
            this.changePasswordDialog = false;
            this.$store.commit("mShowAlert", "Password Updated Successfully.");
            this.loadReport();
          } else {
            this.$store.commit("mShowAlert", "Passwords don't match");
          }
        } else {
          this.$store.commit("mShowAlert", "Missing fields");
        }
      } catch (error) {
        this.$store.commit("mShowAlert", error);
        this.loading = false;
      }
      this.loading = false;
    },
    async addUser() {
      this.loading = true;
      try {
        this.validUser = this.$refs.form.validate();

        if (this.validUser) {
          if (this.editing) {
            await UserService.update(this.user);
          } else {
            await UserService.signUp(this.user);
          }

          this.dialog = false;
          this.$store.commit("mShowAlert", "User Created Successfully.");
          this.loadReport();
        } else {
          this.$store.commit("mShowAlert", "Fill missing fields ");
        }
      } catch (error) {
        this.$store.commit("mShowAlert", error);
        this.loading = false;
      }
      this.loading = false;
    },
    loadReport() {
      this.getReport({
        report: this.report,
        params: this.params,
        view: this.view,
      });
      this.getReport({
        report: "branches",
        params: { company: this.$route.params.code },
      });
    },
    
    sendMoneyForUser(user) {
      console.log("user", user)
      const payload = {
        forUser: user,
      };
      this.mSendMoneyForUser(payload);
    },
    showUser(user){
      console.log("userrrr", user)
    }
  },
  mounted() {
    console.log("usersss", this.users.result);
    this.loadReport();
    console.log("this.users", this.$route.params);
  },
};
</script>